import { render } from "./ObjectAdd.vue?vue&type=template&id=04add842"
import script from "./ObjectAdd.vue?vue&type=script&lang=js"
export * from "./ObjectAdd.vue?vue&type=script&lang=js"

import "./ObjectAdd.vue?vue&type=style&index=0&id=04add842&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__